import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('row-currency'))
    }, [
      (_ctx.row.type === 'fiat')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([
        _ctx.b('row-icon'),
        'fi',
        `fi-${_ctx.row.currency ? _ctx.row.currency.country : _ctx.row.country}`,
      ])
          }, null, 2))
        : (_ctx.row.type === 'crypto' && _ctx.row.name)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: _normalizeClass(_ctx.b('row-icon', { crypto: true })),
              src: require(`@/assets/images/crypto/${_ctx.row.name.toLowerCase()}.svg`),
              alt: _ctx.row.name
            }, null, 10, _hoisted_1))
          : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('row-currency-group'))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('row-currency-label'))
        }, _toDisplayString(_ctx.row.currency ? _ctx.row.currency.name : _ctx.row.name.toUpperCase()), 3),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('row-currency-tag', {
          bank: (_ctx.row.type as string) === 'fiat',
          crypto: (_ctx.row.type as string) === 'crypto',
        })
          )
        }, _toDisplayString((_ctx.row.type as string) === "fiat" ? "Bank Account" : "Crypto Account"), 3)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('row-total'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-total-label'))
      }, _toDisplayString(_ctx.displayedAmount), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('row-actions'))
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(_ctx.b('row-actions-dots', { active: _ctx.isActive })),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isActive = !_ctx.isActive))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('row-action-icon')),
          innerHTML: _ctx.displayedIcons.dots
        }, null, 10, _hoisted_2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('row-actions-list', { visible: _ctx.isActive }))
      }, [
        (_ctx.row.amount > 0)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(_ctx.b('row-action')),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleWithdrawal && _ctx.handleWithdrawal(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('row-action-icon')),
                innerHTML: _ctx.displayedIcons.withdrawalGray
              }, null, 10, _hoisted_3)
            ], 2)), [
              [_directive_tooltip, _ctx.$t('Вывести')]
            ])
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(_ctx.b('row-action')),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDeposit())),
          disabled: _ctx.notVerified
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('row-action-icon')),
            innerHTML: _ctx.displayedIcons.depositGray
          }, null, 10, _hoisted_5)
        ], 10, _hoisted_4)), [
          [_directive_tooltip, _ctx.notVerified ? _ctx.$t('Для получения доступа пройдите процедуру верификации') : _ctx.$t('Пополнить')]
        ]),
        (_ctx.row.amount > 0)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(_ctx.b('row-action')),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleApplication && _ctx.handleApplication(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('row-action-icon')),
                innerHTML: _ctx.displayedIcons.swapGray
              }, null, 10, _hoisted_6)
            ], 2)), [
              [_directive_tooltip, _ctx.$t('Торговать')]
            ])
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(_ctx.b('row-action')),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleHistory && _ctx.handleHistory(...args))),
          disabled: _ctx.notVerified
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('row-action-icon')),
            innerHTML: _ctx.displayedIcons.historyGray
          }, null, 10, _hoisted_8)
        ], 10, _hoisted_7)), [
          [_directive_tooltip, _ctx.notVerified ? _ctx.$t('Для получения доступа пройдите процедуру верификации') : _ctx.$t('История Выводов/Пополнений')]
        ])
      ], 2)
    ], 2)
  ], 2))
}